import { useTranslation } from 'react-i18next';
import RiskSymbolsLegends from './RiskSymbolsLegends';

/**
 * Shared styled card wrapping the risk symbols legend with the standard
 * "Légende :" header on top of "Symboles de risque : <icons>" below.
 * Single source of truth for the legend layout on every fiche detail page.
 *
 * @param {Object} props
 * @param {string} [props.title] - Optional custom link text for the risk symbols link
 * @param {boolean} [props.bordered=true] - Whether to show the card border/background
 * @param {string} [props.className] - Additional className for the outer wrapper
 */
const RiskLegendCard = ({ title, bordered = true, className = '' }) => {
  const { t } = useTranslation('common');
  const cardClasses = bordered
    ? 'rounded-2xl bg-gray-50 border border-gray-200 px-6 py-4'
    : '';

  return (
    <div className={`flex justify-end ${className}`}>
      <div className={cardClasses}>
        <div className="flex flex-col gap-3">
          <span className="text-[16px] font-bold text-black">
            {t('legends.title')}
          </span>
          <RiskSymbolsLegends title={title} />
        </div>
      </div>
    </div>
  );
};

export default RiskLegendCard;
